import { Feeders, TimbaPrediction } from '../api/client';
import { teamCode } from './flags';

// Texto corto del pronóstico cargado: "2–1" o, si fue empate, "2–2 (pen BRA)" usando la abreviatura
// de la selección elegida para la tanda. Si no se pasan los equipos, cae a "(pen 1º/2º)".
export function formatPick(p: TimbaPrediction, t1?: string | null, t2?: string | null): string {
  const base = `${p.g1}–${p.g2}`;
  if (p.g1 === p.g2 && p.pen) {
    const who = p.pen === 1 ? t1 : t2;
    const label = who ? teamCode(who) : p.pen === 1 ? '1º' : '2º';
    return `${base} (pen ${label})`;
  }
  return base;
}

// Lado que el jugador hizo avanzar (1|2) según su pronóstico; null si empate sin penales.
export function predAdvancer(p: TimbaPrediction): number | null {
  if (p.g1 > p.g2) return 1;
  if (p.g2 > p.g1) return 2;
  return p.pen === 1 || p.pen === 2 ? p.pen : null;
}

export interface Mult {
  booster: number; // x1/x2/x3/x4
  bonus: number; // +1 por equipo clavado en el cruce (los dos = +2)
}

// Booster + bonus POTENCIAL: lo que cada partido alcanzaría si los pronósticos del jugador se
// cumplen. Espejo de timba_multipliers del backend, pero "acertar" = haber pronosticado el cruce.
// Devuelve solo los partidos con algún realce (booster>1 o bonus>0).
export function potentialMultipliers(preds: Map<number, TimbaPrediction>, feeders?: Feeders): Map<number, Mult> {
  const tree: Feeders = feeders ?? {};
  const has = (num: number): boolean => {
    const p = preds.get(num);
    return !!p && predAdvancer(p) !== null;
  };
  const cache = new Map<number, number>();
  const boosterOf = (num: number): number => {
    const c = cache.get(num);
    if (c !== undefined) return c;
    const f = tree[num];
    if (!f) {
      cache.set(num, 1);
      return 1;
    }
    const na = parseInt(f[0].slice(1), 10);
    const nb = parseInt(f[1].slice(1), 10);
    const b = has(na) && has(nb) ? Math.min(boosterOf(na), boosterOf(nb)) + 1 : 1;
    cache.set(num, b);
    return b;
  };

  const out = new Map<number, Mult>();
  for (const key of Object.keys(tree)) {
    const num = Number(key);
    const [ea, eb] = tree[num];
    const hits = (has(parseInt(ea.slice(1), 10)) ? 1 : 0) + (has(parseInt(eb.slice(1), 10)) ? 1 : 0);
    const booster = boosterOf(num);
    if (booster > 1 || hits > 0) out.set(num, { booster, bonus: hits });
  }
  return out;
}
